module.exports = __webpack_public_path__ + "img/71.ee605c5.jpg";